const dataRF = [
    {
        CD_PRODUTO: 21,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 810,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 809,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 808,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 807,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 806,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 805,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 804,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 803,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 802,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 797,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 796,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 794,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 790,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 788,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 783,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 778,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 774,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 765,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 753,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 751,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 750,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 748,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 734,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 733,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 732,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 730,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 729,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 726,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 725,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 723,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 721,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 720,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 715,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 714,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 712,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 711,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 710,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 708,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 703,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 702,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 701,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 700,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 699,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 697,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 696,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 695,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 694,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 693,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 692,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 691,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 686,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 685,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 677,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 676,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 669,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 668,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 664,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 661,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 660,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 658,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 657,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 648,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 647,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 639,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 635,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 632,
        NM_PRODUTO: 'Monitoramento'
    },
    {
        CD_PRODUTO: 2284,
        NM_PRODUTO: 'Monitoramento App light'
    },
    {
        CD_PRODUTO: 1786,
        NM_PRODUTO: 'Monitoramento Blindado'
    },
    {
        CD_PRODUTO: 2289,
        NM_PRODUTO: 'Monitoramento Downgrade'
    },
    {
        CD_PRODUTO: 1788,
        NM_PRODUTO: 'Monitoramento Duplo RF'
    },
    {
        CD_PRODUTO: 1791,
        NM_PRODUTO: 'Monitoramento Duplo Smart'
    },
    {
        CD_PRODUTO: 2430,
        NM_PRODUTO: 'Monitoramento Moto'
    },
    {
        CD_PRODUTO: 2431,
        NM_PRODUTO: 'Monitoramento Moto + Assistência Moto eResCD_PRODUT'
    },
    {
        CD_PRODUTO: 1799,
        NM_PRODUTO: 'Monitoramento RF'
    },
    {
        CD_PRODUTO: 1800,
        NM_PRODUTO: 'Monitoramento RF + Garantia'
    },
    {
        CD_PRODUTO: 1801,
        NM_PRODUTO: 'Monitoramento RF Plano Antigo'
    },
    {
        CD_PRODUTO: 1803,
        NM_PRODUTO: 'Monitoramento RF Venda'
    },
    {
        CD_PRODUTO: 1805,
        NM_PRODUTO: 'Monitoramento Smart'
    },
    {
        CD_PRODUTO: 2117,
        NM_PRODUTO: 'Monitoramento Web/Mobile'
    },
    {
        CD_PRODUTO: 2058,
        NM_PRODUTO: 'SMART MOTOS '
    },
    {
        CD_PRODUTO: 2108,
        NM_PRODUTO: 'Rastreador RF MOTOS'
    },
    {
        CD_PRODUTO: 2112,
        NM_PRODUTO: 'Rastreador RF + Assistência'
    },
]

export const handleSomeProductRF = (CD_PRODUTO_SELECTED: number) => dataRF.some(({ CD_PRODUTO }) => CD_PRODUTO === CD_PRODUTO_SELECTED);